<template>
    <div>
        <!-- 一级Tab：总仓切换（动态从接口获取） -->
        <el-tabs type="border-card" v-model="activeMainWarehouseId" @tab-click="handleMainWarehouseChange">
            <el-tab-pane v-for="warehouse in allParentWarehouses" :key="warehouse.houseId" :label="warehouse.houseName"
                :name="warehouse.houseId.toString()">
            </el-tab-pane>
        </el-tabs>

        <!-- 二级Tab：子仓切换（根据当前总仓动态显示） -->
        <el-tabs type="card" v-model="activeSubWarehouseId" @tab-click="handleSubWarehouseChange"
            style="margin-top: 10px;" v-loading="childWarehouseLoading">
            <el-tab-pane v-for="sub in subWarehouseList" :key="sub.houseId" :label="sub.houseName"
                :name="sub.houseId.toString()">
            </el-tab-pane>
        </el-tabs>

        <!-- 食材列表区域 -->
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="食材名称">
                        <el-input v-model="searchForm.materialName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getMaterialList()">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                        <el-button type="success" @click="showAddDialog()">手动出入库</el-button>
                        <el-button type="warning" @click="showAllStockRecord()">子仓总出入库记录</el-button>
                        <el-button type="info" icon="el-icon-download" @click="exportOutboundExcel()">导出数据</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="filteredMaterialList" height="57vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column label="序号" type="index" width="80" align="center" />
                    <el-table-column prop="numId" label="流水号" align="center" width="180" />
                    <!-- 【修复点】将 prop 从 productName 改为 materialName，统一数据源 -->
                    <el-table-column prop="materialName" label="食材名称" align="center" width="180" />
                    <el-table-column prop="shelfLife" label="保质期" align="center" width="120" />
                    <el-table-column prop="untilExpiration" label="临期时间" align="center" width="120" />

                    <!-- 修复操作类型判断：1=入库，其余=出库 -->
                    <el-table-column prop="outFreezer" label="操作类型" align="center" width="120">
                        <template #default="scope">
                            <el-tag :type="scope.row.outFreezer == '1' ? 'success' : 'warning'">
                                {{ scope.row.outFreezer == '1' ? '入库' : '出库' }}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="vendors" label="供应商" align="center" width="120" />
                    <el-table-column prop="num" label="库存量" align="center" width="120" />
                    <el-table-column prop="unit" label="库存单位" align="center" width="150" />

                    <el-table-column prop="expiryDate" label="临期日期" align="center" width="150">
                        <template #default="scope">
                            <span
                                :class="scope.row.expiryDate ? (isExpired(scope.row.expiryDate) ? 'text-red-500 font-bold' : 'text-orange-500 font-bold') : ''">
                                {{ scope.row.expiryDate || '无' }}
                            </span>
                        </template>
                    </el-table-column>

                    <!-- 根据houseId匹配仓库名称显示 -->
                    <el-table-column label="仓库名称" align="center" width="150">
                        <template #default="scope">
                            {{ getWarehouseNameById(scope.row.houseId) || '未知仓库' }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="room" label="功能间" align="center" width="150" />
                    <el-table-column prop="operator" label="操作人" align="center" width="120" />
                    <el-table-column prop="dateTime" label="操作时间" align="center" width="200" />
                    <!-- <el-table-column label="操作" align="center" width="200">
                        <template #default="scope">
                         
                            <el-button size="mini" type="primary" icon="el-icon-edit"
                                @click="showEditDialog(scope.row)">修改</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)"
                                size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;" v-if="totalCount > 0">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 新增/编辑食材弹窗 -->
        <el-dialog title="食材信息" :visible.sync="dialogVisible" width="600px" :before-close="handleDialogClose"
            :z-index="2000" append-to-body modal-append-to-body>
            <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px" class="mt-4">
                <el-form-item label="食材编码" prop="materialCode">
                    <el-input v-model="form.materialCode" placeholder="自动生成或手动输入" />
                </el-form-item>
                <el-form-item label="食材名称" prop="materialName">
                    <el-input v-model="form.materialName" placeholder="请输入食材名称" />
                </el-form-item>

                <el-form-item label="食材类别" prop="materialType">
                    <el-select v-model="form.materialType" placeholder="请选择食材类别">
                        <el-option label="海鲜类" value="海鲜类"></el-option>
                        <el-option label="水产类" value="水产类"></el-option>
                        <el-option label="半成品食物类" value="半成品食物类"></el-option>
                        <el-option label="蛋类" value="蛋类"></el-option>
                        <el-option label="鸡肉类" value="鸡肉类"></el-option>
                        <el-option label="猪肉类" value="猪肉类"></el-option>
                        <el-option label="牛肉类" value="牛肉类"></el-option>
                        <el-option label="羊肉类" value="羊肉类"></el-option>
                        <el-option label="农副产品" value="农副产品"></el-option>
                        <el-option label="蔬菜类" value="蔬菜类"></el-option>
                        <el-option label="菌类" value="菌类"></el-option>
                        <el-option label="粮油米面类" value="粮油米面类"></el-option>
                        <el-option label="调味品" value="调味品"></el-option>
                        <el-option label="其他类" value="其他类"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 所属仓库：自动填充当前选中的总仓+子仓，不可编辑 -->
                <el-form-item label="所属仓库" prop="warehouseName">
                    <el-input v-model="form.warehouseName" placeholder="自动填充当前选中仓库" :disabled="true" />
                </el-form-item>
                <!-- 所属功能间表单项 -->
                <el-form-item label="所属功能间" prop="functionRoom">
                    <el-select v-model="form.functionRoom"
                        :placeholder="functionRoomLoading ? '加载中...' : (functionRoomList.length ? '请选择所属功能间' : '暂无功能间数据')"
                        clearable v-loading="functionRoomLoading">
                        <!-- 【修复点】已正确使用 roomName -->
                        <el-option v-for="room in functionRoomList" :key="room.id" :label="room.roomName"
                            :value="room.roomName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="规格" prop="spec">
                    <el-input v-model="form.spec" placeholder="请输入规格（如：500g/袋）" />
                </el-form-item>
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="form.unit" placeholder="请输入单位（如：kg、袋、个）" />
                </el-form-item>
                <el-form-item label="最低库存" prop="minStock">
                    <el-input v-model.number="form.minStock" placeholder="请输入最低库存数量" />
                </el-form-item>
                <el-form-item label="临期日期" prop="expiryDate">
                    <el-date-picker v-model="form.expiryDate" type="date" placeholder="选择临期日期"
                        value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="供应商" prop="supplier">
                    <el-input v-model="form.supplier" placeholder="请输入供应商名称" />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.remark" type="textarea" placeholder="请输入备注信息" rows="3" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 单个食材出入库记录弹窗 -->
        <el-dialog
            :title="`${currentMaterialName || '食材'} - ${activeMainWarehouseName}-${activeSubWarehouseName} 出入库记录`"
            :visible.sync="materialStockRecordVisible" width="1000px" :z-index="2000" append-to-body
            modal-append-to-body>
            <div class="record-search-bar" style="margin-bottom: 16px;">
                <el-form :inline="true" :model="recordSearchForm" class="demo-form-inline">
                    <el-form-item label="操作时间">
                        <el-date-picker v-model="recordSearchForm.timeRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="操作类型">
                        <el-select v-model="recordSearchForm.operateType" placeholder="全部类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="入库" value="in"></el-option>
                            <el-option label="出库" value="out"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="filterMaterialStockRecord()">查询</el-button>
                        <el-button @click="resetMaterialStockRecordSearch()">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="filteredMaterialStockRecord" border style="width: 100%;">
                <el-table-column label="序号" type="index" width="70" align="center" />
                <el-table-column prop="recordTime" label="操作时间" align="center" />
                <el-table-column prop="operateType" label="操作类型" align="center">
                    <template #default="scope">
                        <el-tag :type="scope.row.operateType === 'in' ? 'success' : 'warning'">
                            {{ scope.row.operateType === 'in' ? '入库' : '出库' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operateNum" label="变动数量" align="center" />
                <el-table-column prop="stockBefore" label="变动前库存" align="center" />
                <el-table-column prop="stockAfter" label="变动后库存" align="center" />
                <el-table-column prop="batchNo" label="批次号" align="center" />
                <el-table-column prop="expiryDate" label="临期日期" align="center">
                    <template #default="scope">
                        <span :class="getExpiryClass(scope.row.expiryStatus)">
                            {{ scope.row.expiryDate || '无' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
            <div style="margin-top: 16px; text-align: center;" v-if="materialStockRecordList.length > 0">
                <el-pagination @size-change="handleRecordSizeChange" @current-change="handleRecordCurrentChange"
                    :current-page="recordCurrentPage" :page-sizes="[10, 20, 50]" :page-size="recordPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="materialStockRecordList.length">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="materialStockRecordVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 子仓总出入库记录弹窗 -->
        <el-dialog :title="`${activeMainWarehouseName}-${activeSubWarehouseName} 总出入库记录`"
            :visible.sync="totalStockRecordVisible" width="1000px" :z-index="2000" append-to-body modal-append-to-body>
            <div class="record-search-bar" style="margin-bottom: 16px;">
                <el-form :inline="true" :model="totalRecordSearchForm" class="demo-form-inline">
                    <el-form-item label="食材名称">
                        <el-input v-model="totalRecordSearchForm.materialName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>
                    <el-form-item label="操作时间">
                        <el-date-picker v-model="totalRecordSearchForm.timeRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="操作类型">
                        <el-select v-model="totalRecordSearchForm.operateType" placeholder="全部类型">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="入库" value="in"></el-option>
                            <el-option label="出库" value="out"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="filterTotalStockRecord()">查询</el-button>
                        <el-button @click="resetTotalStockRecordSearch()">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="filteredTotalStockRecord" border style="width: 100%;">
                <el-table-column label="序号" type="index" width="70" align="center" />
                <el-table-column prop="materialCode" label="食材编码" align="center" />
                <el-table-column prop="materialName" label="食材名称" align="center" />
                <el-table-column prop="recordTime" label="操作时间" align="center" />
                <el-table-column prop="operateType" label="操作类型" align="center">
                    <template #default="scope">
                        <el-tag :type="scope.row.operateType === 'in' ? 'success' : 'warning'">
                            {{ scope.row.operateType === 'in' ? '入库' : '出库' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operateNum" label="变动数量" align="center" />
                <el-table-column prop="stockAfter" label="变动后库存" align="center" />
                <el-table-column prop="operator" label="操作人" align="center" />
                <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
            <div style="margin-top: 16px; text-align: center;" v-if="totalStockRecordList.length > 0">
                <el-pagination @size-change="handleTotalRecordSizeChange"
                    @current-change="handleTotalRecordCurrentChange" :current-page="totalRecordCurrentPage"
                    :page-sizes="[10, 20, 50]" :page-size="totalRecordPageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalStockRecordList.length">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="totalStockRecordVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getStore } from "@/api/warehouse2";
import { getHouseList, getHouseListByPid } from "@/api/terminal";
import { getRoomList } from "@/api/function";

export default {

    data() {
        return {
            houseId: null,
            departments: [],
            loading: false,
            activeMainWarehouseId: '',
            activeSubWarehouseId: '',
            activeMainWarehouseName: '',
            activeSubWarehouseName: '',
            allParentWarehouses: [],
            subWarehouseList: [],
            childWarehouseLoading: false,
            functionRoomList: [],
            functionRoomLoading: false,
            searchForm: {
                materialName: '',
                materialType: '',
                stockStatus: '',
                expiryStatus: ''
            },
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            allMaterialList: [],
            filteredMaterialList: [],
            dialogVisible: false,
            materialStockRecordVisible: false,
            totalStockRecordVisible: false,
            currentMaterialName: '',
            uploadUrl: '/api/upload',
            form: {
                id: '',
                materialCode: '',
                materialName: '',
                materialType: '',
                spec: '',
                unit: '',
                stockNum: 0,
                minStock: 0,
                supplier: '',
                stockStatus: 'normal',
                expiryDate: '',
                expiryStatus: 'normal',
                updateTime: '',
                remark: '',
                imageUrl: '',
                warehouseName: '',
                functionRoom: ''
            },
            formRules: {
                materialName: [{ required: true, message: '请输入食材名称', trigger: 'blur' }],
                materialType: [{ required: true, message: '请选择食材类别', trigger: 'blur' }],
                spec: [{ required: true, message: '请输入食材规格', trigger: 'blur' }],
                unit: [{ required: true, message: '请输入计量单位', trigger: 'blur' }],
                minStock: [
                    { required: true, message: '请输入最低库存', trigger: 'blur' },
                    { type: 'number', min: 1, message: '最低库存不能小于1', trigger: 'blur' }
                ],
                supplier: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
                expiryDate: [{ required: true, message: '请选择临期日期', trigger: 'blur' }],
                warehouseName: [{ required: true, message: '所属仓库不能为空', trigger: 'blur' }],
                functionRoom: [{ required: true, message: '请选择所属功能间', trigger: 'change' }]
            },
            materialStockRecordList: [],
            filteredMaterialStockRecord: [],
            recordSearchForm: {
                timeRange: [],
                operateType: ''
            },
            recordCurrentPage: 1,
            recordPageSize: 10,
            totalStockRecordList: [],
            filteredTotalStockRecord: [],
            totalRecordSearchForm: {
                materialName: '',
                timeRange: [],
                operateType: ''
            },
            totalRecordCurrentPage: 1,
            totalRecordPageSize: 10
        };
    },
    created() {
        this.fetchFunctionRoomList();
    },
    mounted() {
        this.fetchParentWarehouses().then(() => {
            if (this.allParentWarehouses.length > 0 && this.subWarehouseList.length > 0) {

                this.initTotalStockRecordList();
            }
        });
    },
    methods: {
        async fetchFunctionRoomList() {
            this.functionRoomLoading = true;
            try {
                const userId = localStorage.getItem('userId');
                console.log('获取功能间列表，传入的userId:', userId);

                const response = await getRoomList({ userId });
                console.log('getRoomList接口原始返回:', response);

                if (response && response.code === 200) {
                    this.functionRoomList = response.data || [];
                    console.log('成功获取功能间列表:', this.functionRoomList);
                } else {
                    this.$message.error("获取功能间列表失败：" + (response.msg || "未知错误"));
                    this.functionRoomList = [];
                }
            } catch (error) {
                console.error("获取功能间列表接口调用失败（网络或服务器错误）:", error);
                this.$message.error('网络错误，无法获取功能间列表');
                this.functionRoomList = [];
            } finally {
                this.functionRoomLoading = false;
            }
        },
        getWarehouseNameById(houseId) {
            const subWarehouse = this.subWarehouseList.find(item => item.houseId == houseId);
            if (subWarehouse) return subWarehouse.houseName;
            const mainWarehouse = this.allParentWarehouses.find(item => item.houseId == houseId);
            if (mainWarehouse) return mainWarehouse.houseName;
            return null;
        },
        isExpired(dateStr) {
            if (!dateStr) return false;
            const today = new Date();
            const expiryDate = new Date(dateStr);
            today.setHours(0, 0, 0, 0);
            expiryDate.setHours(0, 0, 0, 0);
            return expiryDate < today;
        },
        async fetchParentWarehouses() {
            try {
                this.loading = true;
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: null
                };
                const response = await getHouseList(params);
                if (response.code === 200) {
                    this.allParentWarehouses = response.data || [];
                    if (this.allParentWarehouses.length > 0) {
                        this.activeMainWarehouseId = this.allParentWarehouses[0].houseId.toString();
                        this.activeMainWarehouseName = this.allParentWarehouses[0].houseName;
                        await this.loadChildWarehouses();
                    }
                } else {
                    this.$message.error("获取总仓列表失败：" + (response.msg || "未知错误"));
                }
            } catch (error) {
                console.error("获取总仓列表接口调用失败", error);
                this.$message.error("网络错误，无法获取总仓列表");
            } finally {
                this.loading = false;
            }
        },
        async loadChildWarehouses() {
            if (!this.activeMainWarehouseId) return;
            this.childWarehouseLoading = true;
            try {
                const params = {
                    userId: localStorage.getItem('userId'),
                    pid: this.activeMainWarehouseId,
                };
                const response = await getHouseListByPid(params);
                if (response.code === 200) {
                    this.subWarehouseList = response.data || [];
                    if (this.subWarehouseList.length > 0) {
                        this.activeSubWarehouseId = this.subWarehouseList[0].houseId.toString();
                        this.activeSubWarehouseName = this.subWarehouseList[0].houseName;
                        this.houseId = this.subWarehouseList[0].houseId;
                        this.getStore();
                        this.filterMaterialByWarehouse();
                    } else {
                        this.subWarehouseList = [];
                        this.activeSubWarehouseId = '';
                        this.activeSubWarehouseName = '';
                        this.houseId = null;
                        this.departments = [];
                        this.filteredMaterialList = [];
                        this.totalCount = 0;
                    }
                } else {
                    this.subWarehouseList = [];
                    this.$message.error("获取子仓库列表失败：" + (response.msg || "未知错误"));
                }
            } catch (error) {
                console.error("获取子仓库列表接口调用失败", error);
                this.$message.error("网络错误，无法获取子仓库列表");
                this.subWarehouseList = [];
            } finally {
                this.childWarehouseLoading = false;
            }
        },
        // 在 <script> 的 methods 对象中找到 getStore 方法，进行如下修改

        getStore() {
            if (!this.houseId) {
                this.departments = [];
                return;
            }
            this.loading = true;
            getStore({
                userId: localStorage.getItem('userId'),
                houseId: this.houseId
            })
                .then(response => {
                    if (response && response.code === 200) {
                        this.departments = response.data || [];
                        if (response.data && response.data.length) {
                            // 【核心修改点】在赋值前进行数据转换
                            this.allMaterialList = response.data.map(item => ({
                                ...item, // 保留原始所有字段
                                materialName: item.productName // 将 productName 的值赋给 materialName
                            }));
                            this.filterMaterialByWarehouse();
                        }
                        console.log(`子仓[${this.houseId}]的组织列表：`, this.departments);
                    } else {
                        this.departments = [];
                        this.$message.error(`获取组织列表失败：${response?.msg || '接口返回格式异常'}`);
                    }
                })
                .catch(error => {
                    console.error('获取组织列表接口调用失败：', error);
                    this.departments = [];
                    this.$message.error('网络错误，无法加载组织列表');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async handleMainWarehouseChange(tab) {
            this.activeMainWarehouseId = tab.name;
            const currentMainWarehouse = this.allParentWarehouses.find(
                item => item.houseId.toString() === tab.name
            );
            if (currentMainWarehouse) {
                this.activeMainWarehouseName = currentMainWarehouse.houseName;
            }
            await this.loadChildWarehouses();
            this.currentPage = 1;
            this.initTotalStockRecordList();
        },
        handleSubWarehouseChange(tab) {
            this.activeSubWarehouseId = tab.name;
            const currentSubWarehouse = this.subWarehouseList.find(
                item => item.houseId.toString() === tab.name
            );
            if (currentSubWarehouse) {
                this.activeSubWarehouseName = currentSubWarehouse.houseName;
                this.houseId = currentSubWarehouse.houseId;
                this.getStore();
            }
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
            this.initTotalStockRecordList();
        },
        filterMaterialByWarehouse() {
            const targetWarehouse = `${this.activeMainWarehouseName}-${this.activeSubWarehouseName}`;
            let filtered = this.allMaterialList.filter(item => {
                return item.warehouseName === targetWarehouse || item.houseId == this.houseId;
            });
            filtered = this.filterBySearchForm(filtered);
            this.totalCount = filtered.length;
            this.filteredMaterialList = filtered.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
            );
        },

        initTotalStockRecordList() {
            const today = new Date();
            const targetWarehouse = `${this.activeMainWarehouseName}-${this.activeSubWarehouseName}`;
            const warehouseMaterials = this.allMaterialList.filter(item => item.warehouseName === targetWarehouse);
            const operators = ['张三', '李四', '王五', '赵六', '刘七', '孙八'];
            const remarks = ['日常采购', '正常出库', '补货入库', '损耗出库', '调拨入库', '调拨出库'];
            const totalRecords = [];
            warehouseMaterials.forEach(material => {
                const recordCount = Math.floor(Math.random() * 6) + 5;
                let lastStock = 0;
                for (let i = 0; i < recordCount; i++) {
                    const randomDays = Math.floor(Math.random() * 30);
                    const recordTime = new Date();
                    recordTime.setDate(today.getDate() - randomDays);
                    const formattedTime = recordTime.toISOString().split('T')[0] + ' ' +
                        `${Math.floor(Math.random() * 10) + 8}:${Math.floor(Math.random() * 59) + 1}`;
                    const operateType = Math.random() > 0.4 ? 'in' : 'out';
                    const operateNum = Math.floor(Math.random() * 50) + 10;
                    if (operateType === 'in') {
                        lastStock += operateNum;
                    } else {
                        lastStock = Math.max(0, lastStock - operateNum);
                    }
                    totalRecords.push({
                        id: `${material.id}-${i + 1}`,
                        materialId: material.id,
                        materialCode: material.materialCode,
                        materialName: material.materialName,
                        recordTime: formattedTime,
                        operateType: operateType,
                        operateNum: operateNum,
                        stockAfter: lastStock,
                        operator: operators[Math.floor(Math.random() * operators.length)],
                        remark: remarks[Math.floor(Math.random() * remarks.length)],
                        warehouseName: targetWarehouse
                    });
                }
            });
            totalRecords.sort((a, b) => new Date(b.recordTime) - new Date(a.recordTime));
            this.totalStockRecordList = totalRecords;
            this.filteredTotalStockRecord = this.getPagedTotalRecord();
        },
        initMaterialStockRecord(material) {
            const today = new Date();
            const operators = ['张三', '李四', '王五', '赵六', '刘七', '孙八'];
            const remarks = ['日常采购', '正常出库', '补货入库', '损耗出库', '调拨入库', '调拨出库'];
            const batchNos = [];
            for (let i = 0; i < 10; i++) {
                batchNos.push('B' + Math.floor(Math.random() * 1000000).toString().padStart(6, '0'));
            }
            const records = [];
            let lastStock = 0;
            const recordCount = Math.floor(Math.random() * 11) + 10;
            for (let i = 0; i < recordCount; i++) {
                const randomDays = Math.floor(Math.random() * 30);
                const recordTime = new Date();
                recordTime.setDate(today.getDate() - randomDays);
                const formattedTime = recordTime.toISOString().split('T')[0] + ' ' +
                    `${Math.floor(Math.random() * 10) + 8}:${Math.floor(Math.random() * 59) + 1}:${Math.floor(Math.random() * 59) + 1}`;
                const operateType = Math.random() > 0.4 ? 'in' : 'out';
                const operateNum = Math.floor(Math.random() * 50) + 10;
                const stockBefore = lastStock;
                if (operateType === 'in') {
                    lastStock += operateNum;
                } else {
                    lastStock = Math.max(0, lastStock - operateNum);
                }
                const materialExpiry = new Date(material.expiryDate);
                const expiryDate = new Date(materialExpiry);
                expiryDate.setDate(materialExpiry.getDate() - Math.floor(Math.random() * 5));
                const formattedExpiry = expiryDate.toISOString().split('T')[0];
                const daysDiff = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
                const expiryStatus = daysDiff < 0 ? 'expired' : daysDiff <= 3 ? 'near' : 'normal';
                records.push({
                    id: `${material.id}-record-${i + 1}`,
                    materialId: material.id,
                    recordTime: formattedTime,
                    operateType: operateType,
                    operateNum: operateNum,
                    stockBefore: stockBefore,
                    stockAfter: lastStock,
                    batchNo: batchNos[Math.floor(Math.random() * batchNos.length)],
                    expiryDate: formattedExpiry,
                    expiryStatus: expiryStatus,
                    operator: operators[Math.floor(Math.random() * operators.length)],
                    remark: remarks[Math.floor(Math.random() * remarks.length)]
                });
            }
            records.sort((a, b) => new Date(b.recordTime) - new Date(a.recordTime));
            this.materialStockRecordList = records;
            this.filteredMaterialStockRecord = this.getPagedMaterialRecord();
        },
        // 【修复点】简化搜索逻辑，只针对 materialName 进行搜索
        filterBySearchForm(data) {
            const { materialName, materialType, stockStatus, expiryStatus } = this.searchForm;
            return data.filter(item => {
                const matchName = materialName ? item.materialName.includes(materialName) : true;
                const matchType = materialType ? item.materialType === materialType : true;
                const matchStock = stockStatus ? item.stockStatus === stockStatus : true;
                const matchExpiry = expiryStatus ? item.expiryStatus === expiryStatus : true;
                return matchName && matchType && matchStock && matchExpiry;
            });
        },
        getMaterialList() {
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },
        resetSearch() {
            this.searchForm = {
                materialName: '',
                materialType: '',
                stockStatus: '',
                expiryStatus: ''
            };
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },
        filterMaterialStockRecord() {
            const { timeRange, operateType } = this.recordSearchForm;
            let filtered = [...this.materialStockRecordList];
            if (timeRange && timeRange.length === 2) {
                const start = new Date(timeRange[0]);
                const end = new Date(timeRange[1]);
                filtered = filtered.filter(item => {
                    const recordTime = new Date(item.recordTime);
                    return recordTime >= start && recordTime <= end;
                });
            }
            if (operateType) {
                filtered = filtered.filter(item => item.operateType === operateType);
            }
            this.recordCurrentPage = 1;
            this.filteredMaterialStockRecord = this.getPagedMaterialRecord(filtered);
        },
        resetMaterialStockRecordSearch() {
            this.recordSearchForm = {
                timeRange: [],
                operateType: ''
            };
            this.recordCurrentPage = 1;
            this.filteredMaterialStockRecord = this.getPagedMaterialRecord();
        },
        filterTotalStockRecord() {
            const { materialName, timeRange, operateType } = this.totalRecordSearchForm;
            let filtered = [...this.totalStockRecordList];
            if (materialName) {
                filtered = filtered.filter(item => item.materialName.includes(materialName));
            }
            if (timeRange && timeRange.length === 2) {
                const start = new Date(timeRange[0]);
                const end = new Date(timeRange[1]);
                filtered = filtered.filter(item => {
                    const recordTime = new Date(item.recordTime);
                    return recordTime >= start && recordTime <= end;
                });
            }
            if (operateType) {
                filtered = filtered.filter(item => item.operateType === operateType);
            }
            this.totalRecordCurrentPage = 1;
            this.filteredTotalStockRecord = this.getPagedTotalRecord(filtered);
        },
        resetTotalStockRecordSearch() {
            this.totalRecordSearchForm = {
                materialName: '',
                timeRange: [],
                operateType: ''
            };
            this.totalRecordCurrentPage = 1;
            this.filteredTotalStockRecord = this.getPagedTotalRecord();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.filterMaterialByWarehouse();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.filterMaterialByWarehouse();
        },
        getPagedMaterialRecord(data = null) {
            const source = data || this.materialStockRecordList;
            return source.slice(
                (this.recordCurrentPage - 1) * this.recordPageSize,
                this.recordCurrentPage * this.recordPageSize
            );
        },
        handleRecordSizeChange(val) {
            this.recordPageSize = val;
            this.recordCurrentPage = 1;
            this.filteredMaterialStockRecord = this.getPagedMaterialRecord();
        },
        handleRecordCurrentChange(val) {
            this.recordCurrentPage = val;
            this.filteredMaterialStockRecord = this.getPagedMaterialRecord();
        },
        getPagedTotalRecord(data = null) {
            const source = data || this.totalStockRecordList;
            return source.slice(
                (this.totalRecordCurrentPage - 1) * this.totalRecordPageSize,
                this.totalRecordCurrentPage * this.totalRecordPageSize
            );
        },
        handleTotalRecordSizeChange(val) {
            this.totalRecordPageSize = val;
            this.totalRecordCurrentPage = 1;
            this.filteredTotalStockRecord = this.getPagedTotalRecord();
        },
        handleTotalRecordCurrentChange(val) {
            this.totalRecordCurrentPage = val;
            this.filteredTotalStockRecord = this.getPagedTotalRecord();
        },
        showAddDialog() {
            this.dialogVisible = true;
            const warehouseName = `${this.activeMainWarehouseName}-${this.activeSubWarehouseName}`;
            const defaultExpiry = new Date();
            defaultExpiry.setDate(defaultExpiry.getDate() + 7);
            this.form = {
                id: '',
                materialCode: `MAT${20240001 + this.allMaterialList.length}`,
                materialName: '',
                materialType: '',
                spec: '',
                unit: '',
                stockNum: 0,
                minStock: 10,
                supplier: '',
                stockStatus: 'normal',
                expiryDate: defaultExpiry.toISOString().split('T')[0],
                expiryStatus: 'normal',
                updateTime: new Date().toLocaleString('zh-CN', {
                    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
                }).replace(/\//g, '-'),
                remark: '',
                imageUrl: '',
                warehouseName: warehouseName,
                functionRoom: ''
            };
            this.$nextTick(() => this.$refs.formRef?.clearValidate());
        },
        showEditDialog(row) {
            this.dialogVisible = true;
            this.form = { ...row };
            this.$nextTick(() => this.$refs.formRef?.clearValidate());
        },
        showMaterialStockRecord(row) {
            this.currentMaterialName = row.materialName;
            this.initMaterialStockRecord(row);
            this.materialStockRecordVisible = true;
        },
        showAllStockRecord() {
            this.totalStockRecordVisible = true;
            this.filteredTotalStockRecord = this.getPagedTotalRecord();
        },
        handleDialogClose() {
            this.dialogVisible = false;
            this.$refs.formRef?.clearValidate();
        },
        submitForm() {
            this.$refs.formRef.validate((isValid) => {
                if (isValid) {
                    const today = new Date();
                    const expiryDate = new Date(this.form.expiryDate);
                    const daysDiff = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
                    this.form.expiryStatus = daysDiff < 0 ? 'expired' : daysDiff <= 3 ? 'near' : 'normal';
                    this.form.stockStatus = this.form.stockNum <= 0 ? 'out' : this.form.stockNum <= this.form.minStock ? 'low' : 'normal';
                    this.form.updateTime = new Date().toLocaleString('zh-CN', {
                        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
                    }).replace(/\//g, '-');
                    if (!this.form.id) {
                        this.form.id = `${this.form.warehouseName}-${Date.now()}`;
                        this.form.numId = `SN${Date.now().toString().slice(-6)}`;
                        this.form.num = this.form.stockNum;
                        this.form.vendors = this.form.supplier;
                        this.form.untilExpiration = this.form.expiryDate;
                        this.form.base64Data = this.form.imageUrl;
                        this.form.houseId = this.houseId;
                        this.form.room = this.form.functionRoom;
                        this.form.operator = localStorage.getItem('username') || '管理员';
                        this.form.dateTime = new Date().toLocaleString('zh-CN');
                        this.allMaterialList.push({ ...this.form });
                        this.initTotalStockRecordList();
                        this.$message.success('新增食材成功');
                    } else {
                        const index = this.allMaterialList.findIndex(item => item.id === this.form.id);
                        if (index !== -1) {
                            this.form.num = this.form.stockNum;
                            this.form.vendors = this.form.supplier;
                            this.form.untilExpiration = this.form.expiryDate;
                            this.form.base64Data = this.form.imageUrl;
                            this.form.room = this.form.functionRoom;
                            this.allMaterialList.splice(index, 1, { ...this.form });
                        }
                        this.$message.success('编辑食材成功');
                    }
                    this.filterMaterialByWarehouse();
                    this.dialogVisible = false;
                }
            });
        },
        handleDelete(id) {
            this.$confirm('此操作将永久删除该食材记录及关联的出入库记录, 是否继续?', '提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.allMaterialList = this.allMaterialList.filter(item => item.id !== id);
                this.initTotalStockRecordList();
                this.filterMaterialByWarehouse();
                this.$message.success('删除成功');
            }).catch(() => this.$message.info('已取消删除'));
        },
        handleImageUploadSuccess(response, file) {
            this.form.imageUrl = response.url || URL.createObjectURL(file.raw);
        },
        beforeImageUpload(file) {
            const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPGOrPNG) this.$message.error('上传图片只能是 JPG/PNG 格式!');
            if (!isLt2M) this.$message.error('上传图片大小不能超过 2MB!');
            return isJPGOrPNG && isLt2M;
        },
        formatType(type) {
            const typeMap = { vegetable: '蔬菜类', meat: '肉类', seafood: '水产类', grainOil: '粮油类', driedGoods: '干货类' };
            return typeMap[type] || type;
        },
        getStatusTagType(status) {
            return status === 'normal' ? 'success' : status === 'low' ? 'warning' : 'danger';
        },
        getExpiryTagType(status) {
            return status === 'normal' ? 'success' : status === 'near' ? 'warning' : 'danger';
        },
        getExpiryClass(status) {
            return status === 'expired' ? 'text-red-500 font-bold' : status === 'near' ? 'text-orange-500 font-bold' : '';
        },
        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        },
        exportOutboundExcel() {
            this.loading = true;
            const userId = localStorage.getItem('userId');
            const houseId = this.houseId;
            const baseDownloadUrl = 'http://zhongyan.a1.luyouxia.net:20807/inventory/getStore/export';
            if (!userId || !houseId) {
                this.loading = false;
                this.$message.error('参数不完整，无法下载');
                return;
            }
            try {
                const finalUrl = new URL(baseDownloadUrl);
                finalUrl.searchParams.append('userId', String(userId));
                finalUrl.searchParams.append('houseId', String(houseId));
                const downloadUrlStr = finalUrl.toString();
                console.log('完整下载地址：', downloadUrlStr);
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = downloadUrlStr;
                iframe.onload = () => {
                    setTimeout(() => {
                        this.loading = false;
                        this.$message.success('下载已触发，请等待浏览器响应');
                    }, 1000);
                };
                iframe.onerror = () => {
                    this.loading = false;
                    console.error('iframe下载请求错误');
                    this.$message.error('下载失败，请检查网络或刷新页面重试');
                };
                document.body.appendChild(iframe);
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 5000);
            } catch (error) {
                this.loading = false;
                console.error('下载流程异常：', error);
                this.$message.error('下载失败，请重试');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.text-orange-500 {
    color: #e6a23c;
}

.text-blue-500 {
    color: #409eff;
}

.font-bold {
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
    object-fit: cover;
}

.upload-tip {
    margin-top: 10px;
    color: #606266;
    font-size: 12px;
}

.image-error {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #8c939d;
}

::v-deep .el-tabs__header {
    margin-bottom: 0 !important;
}

::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}

.record-search-bar {
    background-color: #f7f8fa;
    padding: 12px 16px;
    border-radius: 6px;
}
</style>